<template>
<div id="OpticalHome" > 
<Subtitle  v-bind:ServiceID="this.AppServiceID" v-bind:MainPage="true">
   <template v-slot:header>
    <i class="fas fa-igloo"></i><b>Optical Home:</b>
  </template> 
</Subtitle>
<Card>
<CardBody>
<p>Any personal health information accessed through the Optical application is the property of the Government of Saskatchewan. Access to the contents of this site except by agencies <b>AUTHORIZED BY SASKATCHEWAN HEALTH IN WRITING</b> or their authorized employees is strictly prohibited. All transactions are monitored, logged and reviewed. 
</p>
<TileNote>
  <strong>Please Note:</strong> Legal action will be taken against any person accessing information without prior approval from Saskatchewan Health AND THOSE WHO UTILIZE THE INFORMATION FOR UNAUTHORIZED OR UNLAWFUL PURPOSES. 
</TileNote> 
</CardBody>
</Card>

<Card v-if="ShowGrid" style="margin-bottom:1px !important">
<CardBody style="margin-bottom:1px !important"> 
  <TileNote>
     <strong>New Bulletins : </strong> New Bulletins are available to view !
  </TileNote>
  <v-client-table :columns="columns" :data="tableData" :options="options"  > 
    <span class="pointer"  v-on:click="getPDF(props.row)" slot="bulletinname" slot-scope="props" ><u>{{props.row.bulletinname}}</u></span> 
</v-client-table> 
 </CardBody>
</Card>
</div>
</template>
<script>
import {mapGetters} from 'vuex';
import Subtitle from '@/Common/Default/SubTitle.vue'; 
import axios from 'axios'
import LayoutDefault from '@/Common/Default/DefaultLayout.vue'; 
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import moment from 'moment';
import Vue from 'vue';
export default  {
  data: function () {
    return {
        AppServiceID :'',
        dateFormat:'',
        ShowGrid:false,
        ShowHomeBtn:false,
            columns: ['bulletinname','effectivedate','expirydate'],
            tableData: [],
            options: {
                texts:{
                    count:"Showing {from} to {to} of {count} records|{count} records|One record",
                    first:'First',
                    last:'Name',
                    filter:"Search Bulletin Data:",
                    filterPlaceholder:"Search in table",
                    limit:"Records:",
                    page:"Page:",
                    noResults:"No matching records",
                    filterBy:"Filter by {column}",
                    loading:'Loading...',
                    defaultOption:'Select {column}',
                    columns:'Columns'
                },
                perPage:10,
                filterable:false,
                perPageValues:[10,15,25],
               // dateColumns:['effectivedate','expirydate'],
                toMomentFormat: 'YYYY-MM-DD', 
                templates: {
                  effectivedate(h, row){
                     
                      return moment(row.effectivedate, "YYYY-MM-DD").format('YYYY/MM/DD'); 
                  },
                  // postdate(h, row) {
                  //     return moment(row.postdate, "YYYY-MM-DD").format('YYYY/MM/DD'); 
                  // },
                  expirydate(h, row) {
                      return moment(row.expirydate, "YYYY-MM-DD").format('YYYY/MM/DD'); 
                  },
                },                    
                headings: { 
                  bulletinname: 'Bulletin Name',
                  //name: 'Service Type',
                  effectivedate: 'Effective Date',
                  //postdate: 'Post Date',
                  expirydate: 'Expiry Date',
                  //createuser: "Created By",
                  createddatetime: "Created Date",
                  //updateuser: 'Modified By',
                  //lastmodifieddatetime: "Modified Date"
                },
                pagination: {
                    edge: true,
                    nav: 'scroll',
                    chunk: 5
                },
                sortable: ['bulletinname','effectivedate', 'expirydate'],
               // filterable: [ ],
                sortIcon: {
                    base : 'fas',
                    is: 'fa-sort',
                    up: 'fa-sort-up',
                    down: 'fa-sort-down'
                },
            }, 
        }
    },
    components: {
           
            Card,
            CardBody,
            TileNote ,
            Subtitle        
        },
        methods: {
         Go(){
            this.$router.push('/DPEBB/MainHome')
        },
        loadTable(){ 
        var vm = this;
        var url = 'SaskHealthApi/Security/GetBulletinsByEffDate?_='
         var params = new URLSearchParams();
         params.append("id", vm.AppServiceID);
         axios.get(url+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
        .then(function (response) { 
            vm.tableData=response.data; 
            })
            .catch(function (er) {
                console.log(er)
            }).then(function () {
              console.log("length: " + vm.tableData.length)
              if(vm.tableData.length>0)
              vm.ShowGrid = true;
            });  
          },
        getPDF:function(Rowdata){ 
        const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = []; 
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize); 
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
            } 
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        } 
        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
        }   
          var vm = this;
          var url = 'SaskHealthApi/Security/GetPDF?_='
          var params = new URLSearchParams();
          params.append("id", Rowdata.id);
          axios.get(url+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
          .then(function (response) {
                const contentType = 'application/pdf';
              const blob = b64toBlob(response.data.pdf , contentType); 
              const fileName = Rowdata.pdfname; 
              var win = open('', '_blank'); 
              win.document.write(
                  '<html><body><center>' +
                  '<a title="Download PDF" style="font-family: \'Verdana\';color: #333;text-decoration: none;font-weight: 600;" download="' + Rowdata.pdfname + '" href="data:application/pdf;base64,' + response.data.pdf + '">Download File</a>' +
                  '</center><br>' +
                  '<object width=100% height=100% type="application/pdf" data="data:application/pdf;base64,' + response.data.pdf  + '">' +
                  '<embed type="application/pdf" src="data:application/pdf;base64,' + response.data.pdf  + '" id="embed_pdf"></embed>' +
                  '</object></body></html>'); 
                })
          .catch(function (er) {
                console.log(er)
          });
        },
        CanAccessAllApp(){
            var vm = this;
              axios.get('SaskHealthApi/Codes/AccessAllApp', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }})
             .then(function (response) {
                   vm.ShowHomeBtn = response.data; 
                })
            .catch(function (er) {
                console.log(er)
            }).then(function()
            {  
            })
        },
    },
    computed:{ 
    },
     created: function() { 
        this.$emit('update:layout', LayoutDefault);
        const auth = this.$store.getters.IsAuth;
      if (auth) { 
        this.dateFormat = this.$store.getters.GetDateFormat; 
        this.AppServiceID =this.$store.getters.GetOpticalID;
        this.CanAccessAllApp();  
        this.loadTable();
      }
    },
    beforeCreate: function() {  
         this.$store.dispatch('AddServiceID',this.$store.getters.GetOpticalID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetOpticalID); 
    }, 
}
</script>